import styled from 'styled-components'
import comingSoon from '../images/inkandtimecomingsoon.png'

const ComingSoon = styled.div`
  background-image: url(${comingSoon});
  background-repeat:no-repeat;
  background-attachment:fixed;
  background-position:100% 100%;
  background-size:cover;  
  height: 100vh;
  width: 100vw;
`

export default ComingSoon
